module.exports = __webpack_public_path__ + "static/vision-and-visionaries-757006c590b916e3cee7a5f050f341db.jpg";